export default __webpack_public_path__ + "static/media/banner-upload-placeholder.08ae2a53.png";